module.exports = __webpack_public_path__ + "img/unionpay1.61d0ab14.png";